exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel {\r\n    margin-bottom: 20px;\r\n    background-color: #fff;\r\n    border-radius: 4px;\r\n    box-shadow: 0 1px 1px rgba(0, 0, 0, .05);\r\n}\r\n\r\n.menu-icon {\r\n  width: 20px; /* Adjust width as needed */\r\n  height: 20px; /* Adjust height as needed */\r\n  -o-object-fit: contain;\r\n     object-fit: contain; /* Ensures the image fits within the dimensions */\r\n}\r\n\r\n/* Hover state for the <li> */\r\n.panel:hover .menu-icon {\r\n  -webkit-filter: brightness(0) invert(1);\r\n          filter: brightness(0) invert(1);\r\n}\r\n\r\n.minified nav > ul > li > a > .menu-item-parent {\r\n    background-color: #43425d !important;\r\n    color: #444 !important;\r\n    border-top-right-radius: 15px;\r\n}\r\n\r\n.minifyme, .minifyme:hover{\r\n  position: fixed !important;\r\n  bottom: 0 !important;\r\n  border-radius: 0 !important;\r\n  width: 100% !important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/layout/sidebar/sidebar.component.css
// module id = ../../../../../src/app/layout/sidebar/sidebar.component.css
// module chunks = main